<template>
  <div
    class="base-input-file"
    :class="classObject"
  >
    <input
      ref="input"
      type="file"
      class="base-input-file__input-file"
      :accept="accept"
      multiple
      :name="name"
      @change="onChange($event)"
    >
    <label
      class="base-input-file__label"
      @click="onClick()"
    >{{ label }}</label>
    <div class="d-flex">
      <span
        v-if="prefix"
        class="base-input-file__prefix"
      >{{ prefix }}</span>
      <div
        class="base-input-file__input"
        @click="onClick()"
      >
        {{ fileName }}
      </div>
    </div>
    <hr class="base-input-file__line">
    <div
      class="base-input-file__feedback"
      :class="'base-input-file__feedback--' + status"
    >
      {{ message }}
    </div>
    <div
      class="base-input-file__feedback-icon"
      @click="onClick()"
    >
      <i
        v-if="status == 'error'"
        class="fas fa-times"
      />
      <i
        v-if="status == 'success'"
        class="fas fa-check"
      />
      <i
        v-if="!status"
        class="fas fa-upload"
      />
    </div>

    <div v-if="debug">
      <pre>
        isDirty: {{ dirty }}
        name: {{ name }}
        value: {{ data }}
        status: {{ status }}
        message: {{ message }}
      </pre>
      <input
        v-model="dirty"
        type="checkbox"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseInputFile',
  props: {
    label: String,
    name: String,
    value: [String, HTMLInputElement],
    status: String,
    message: String,
    prefix: String,
    multipleLabel: {
      type: String,
      default: 'Multiple files...',
    },
    accept: {
      type: String,
      default: 'image/png, image/jpeg',
    },
  },
  data() {
    return {
      data: '',
      dirty: false,
      debug: false,
      file_name: '',
      files: [],
      preview_url: [],
    };
  },
  computed: {
    classObject() {
      const classes = {};
      classes[`${this.$options.name}--dirty`] = this.dirty;
      classes[`${this.$options.name}--with-feedback`] = this.message;
      classes[`${this.$options.name}--${this.status}`] = this.status;
      return classes;
    },
    fileName: {
      get() {
        return this.file_name || this.value;
      },
      set(value) {
        this.file_name = value;
      },
    },
  },
  mounted() {
    console.log('VAL', this.value);
    if (this.value) {
      this.dirty = true;
      this.data = this.value;
    }
  },
  methods: {
    onClick() {
      this.$refs.input.click();
    },
    loadImagePreview(index = 0) {
      const reader = new FileReader();
      reader.onload = (e) => {
        // $('#blah').attr('src', e.target.result);
        this.preview_url[index] = e.target.result;
        this.$emit('imageloaded', index, this.preview_url[index]);
      };
      reader.readAsDataURL(this.files[index]);
    },
    onChange(evt) {
      if (evt.target.files.length <= 0) {
        return;
      }

      this.files = evt.target.files;

      // eslint-disable-next-line
      for (let i = 0; i < this.files.length; i++) {
        if (!this.preview_url[i]) {
          this.loadImagePreview(i);
        }
      }

      if (this.files.length > 1) {
        this.fileName = this.multipleLabel;
        this.dirty = true;
      } else {
        // Single
        this.fileName = evt.target.files[0].name;
        const event = new CustomEvent(
          `base:${this.$options.name}:${this.name}:changed`,
          {
            detail: {
              target: evt.target,
            },
          },
        );
        window.dispatchEvent(event);

        this.$emit('input', evt.target);
        this.dirty = true;
      }
    },
  },
};
</script>
<style lang="scss">
.base-input-file {
    $b: &;

    position: relative;
    // margin-top: 1rem;
    margin-bottom: 1rem;
    padding: 1px;

    &--dirty {
        #{$b}__label {
            top: -1rem;
            left: 1rem;
            font-size: 0.875rem;
            color: $primary;
            text-transform: uppercase;
            z-index: 2;
        }
    }

    &__input-file {
        display: none;
    }

    &__label {
        color: #717171;
        font-size: 1.125rem;
        display: block;
        position: absolute;
        left: 1.235rem;
        top: 0.5rem;
        transition: all 0.2s;
    }

    &__prefix {
        font-size: 1.125rem;
        padding: 0.5rem 1rem;
        padding-right: 0;
        color: #ddd;
        display: none;

        #{$b}--dirty & {
            display: inline-block;
        }
    }

    &__input {
        border: none;
        background: #fdfdfd;
        height: 2.6875rem;
        left: 0;
        bottom: 0;
        display: block;
        font-size: 1.125rem;
        padding: 0.5rem 1rem;
        margin-bottom: 0;
        width: 100%;
        color: #666;
        &:focus {
            outline: none;
        }
    }

    &__line {
        border: none;
        margin-top: 0;
        margin-bottom: 0;
        border-bottom: solid 1px #ccc;

        #{$b}--error & {
            border-bottom: solid 2px $danger;
        }

        #{$b}--success & {
            border-bottom: solid 2px $success;
        }
    }

    &__feedback {
        margin-bottom: 1rem;
        padding: 0 1rem;
        font-size: 0.875rem;

        #{$b}--error & {
            color: $danger;
        }

        #{$b}--success & {
            color: $success;
        }
    }
    &__feedback-icon {
        top: 1.1rem;
        position: absolute;
        right: 0;
        width: 20px;
        #{$b}--error & {
            color: $danger;
        }

        #{$b}--success & {
            color: $success;
        }
    }
}
</style>
